import CommonColorUtils from "./common_colors";

export const styleContainerList = {
    flex: 1,
    overflowY: 'auto',
};
export const styleTableCellHeader = {
    height: "43px",
    backgroundColor: CommonColorUtils.primaryGrey300,
    padding: "0px",
    paddingLeft: "10px",
    paddingRight: "20px",
    position: "sticky",
    top: 0,
    zIndex: 100,
    fontFamily: "Inter, Arial, sans-serif",
    color: "#6F727A",
    fontWeight: "600",
    fontSize: "12px",
};
export const styleListingOutLine = {
    margin: "30px 15px",
    borderTopLeftRadius: "16px",
    borderRadius: "16px",
    border: `1px solid ${CommonColorUtils.primaryGrey300}`,
    height: '80%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
};
